var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('e-dialog',{attrs:{"dialogTitle":"易派客提醒您","centerDialogVisible":_vm.costCoverageVisible,"popupWidth":'420px'},on:{"resetPopupData":_vm.resetPopupData,"submitPopupData":_vm.submitPopupData}},[_c('div',[_vm._v("该产品只收取高等级费用（1级为最高等级），请问是否自动覆盖？")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }